export const iconFontAwesomeFoodBeverageBone = (
	<i className="fa-solid fa-bone"></i>
);
